import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface DeanDealershipNoticeProps {
  canImpersonate: boolean;
  onViewAsDealer: () => void;
}

export function DeanDealershipNotice({
  canImpersonate,
  onViewAsDealer,
}: DeanDealershipNoticeProps) {
  const { t } = useTranslation(["dean"]);

  return (
    <div
      role="status"
      data-testid="dean-membership-required"
      className="flex items-start gap-3 rounded-lg border bg-muted/40 p-4"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10">
        <Sparkles className="h-4 w-4 text-primary" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium leading-tight">
          {t("dean:dealershipRequired.title")}
        </p>
        <p className="mt-1 text-sm text-muted-foreground">
          {t(
            canImpersonate
              ? "dean:dealershipRequired.description"
              : "dean:dealershipRequired.descriptionWithoutImpersonation",
          )}
        </p>
        {canImpersonate && (
          <Button
            type="button"
            size="sm"
            className="mt-3"
            onClick={onViewAsDealer}
            data-testid="button-dean-view-as-dealer"
          >
            {t("dean:dealershipRequired.viewAsDealer")}
          </Button>
        )}
      </div>
    </div>
  );
}
